export function getNestedValue(obj: any, path: string) {
    return path
        .split(/[[\].]+/)
        .filter(Boolean)
        .reduce((acc, key) => {
            return acc && acc[key] !== undefined ? acc[key] : undefined
        }, obj)
}

export function parseFormValue(value: unknown): string {
    if (typeof value === 'string') {
        return value.trim()
    }
    if (value === null || value === undefined) {
        return ''
    }
    if (typeof value === 'number' || typeof value === 'boolean') {
        return String(value)
    }
    return ''
}
